import { sendTrack } from './track';

export async function fetchAddressDetails({
  streetLineWithSecondary,
  city,
  state,
  zipcode,
  estimateUrl
} = {}) {
  const url =
    estimateUrl || globalThis.unlk?.estimateUrl || globalThis.unlk?.estimate;

  if (!url) throw new Error('Missing Estimate Endpoint URL');

  let response = false;

  try {
    const resp = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      body: JSON.stringify({
        // eslint-disable-next-line camelcase
        pre_application_flow_uuid: crypto.randomUUID(),
        street: streetLineWithSecondary,
        city,
        state,
        // eslint-disable-next-line camelcase
        zip_code: zipcode
      })
    });

    const addressDetails = await resp.json();

    // eslint-disable-next-line no-console
    console.log('addressDetails', addressDetails);

    sendTrack('Property Inquiry Made', {
      street: streetLineWithSecondary,
      city,
      state,
      // eslint-disable-next-line camelcase
      zip_code: zipcode
    });

    response = addressDetails;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);

    sendTrack('Property Inquiry Failed', {
      search: `${streetLineWithSecondary} ${city}, ${state}, ${zipcode}`,
      error
    });
  } finally {
    // eslint-disable-next-line no-unsafe-finally
    return response;
  }
}
